/* « ADD A 3RD KIT » DANS LE TIROIR PANIER (14/10/2026, demande Robin)
   04/11/2026 (Robin, modèle Anavrin) : kits proposés à LEUR prix seul + « + Add », lien vers /pages/build-your-bundle.
   Quand le panier contient 2 kits (ou 5, 8…), le prochain kit tombe sur −20 % : on propose
   3 kits en tête de la colonne « Complete your kit », avec le prix réel et l'économie exacte.
   - Kits : flux /collections/best-sellers?view=drawerkits (prix dans la devise du visiteur),
     même famille que les kits du panier d'abord, jamais un kit déjà au panier, ni un produit
     à variantes (ajout en un clic seulement).
   - Calcul : règle de la Function (groupes de 3, tri par prix décroissant, −15 % / −20 %,
     remise arrondie VERS LE BAS au centime ; pool = vrais kits s'il y en a au moins 2).
   - Le tiroir est re-rendu par le thème à chaque changement de panier : un observateur sur
     #minicart-form ré-injecte le bloc. Ajout via /cart/add.js + re-rendu + cartAction()
     UNE fois (sinon les boutons code promo / note s'ouvrent puis se referment).
   - Mesure : attribut de panier _bn_src_drawer3 (voir window.bnTrackSource). */
(function(){
  if (window.__bnDrawer3) return; window.__bnDrawer3 = true;
  var PCT = [0, 15, 20], FEED = null, CART = null, busy = false, timer = null, SYNC = false;

  function money(c){
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      // 29/10 : CAD / AUD en « $81.00 CAD » / « $82.00 AUD » (décision Robin)
      var sym = (code === 'CAD' || code === 'AUD');
      var nf = new Intl.NumberFormat(undefined, {style: 'currency', currency: code, currencyDisplay: 'narrowSymbol'});
      return nf.format(c / Math.pow(10, nf.resolvedOptions().maximumFractionDigits)) + (sym ? ' ' + code : '');
    } catch(e){ return '$' + (c / 100).toFixed(2); }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function fam(t){
    t = String(t || '').toLowerCase();
    if (t.indexOf('book nook') > -1) return 'nook';
    if (t.indexOf('house') > -1) return 'house';
    if (t.indexOf('jigsaw') > -1) return 'jigsaw';
    if (t.indexOf('puzzle') > -1 || t.indexOf('music box') > -1) return 'puzzle';
    return 'other';
  }
  function total(items){
    var real = items.filter(function(x){ return !x.acc; });
    var pool = real.length >= 2 ? real : items;
    var t = 0;
    pool.map(function(x){ return x.p; }).sort(function(a, b){ return b - a; })
      .forEach(function(p, i){ t += p - Math.floor(p * PCT[i % 3] / 100 + 1e-7); });
    items.forEach(function(x){ if (pool.indexOf(x) < 0) t += x.p; });
    return t;
  }
  /* 16/10 (Robin) : prix barré SEULEMENT si la remise tombe sur ce kit dans le panier. La Function
     remise les kits les MOINS CHERS : ajouter un kit plus cher fait baisser un AUTRE article ; afficher
     ce kit barré annonçait alors un prix de ligne faux (le panier le montrait à plein tarif). Égalité de
     prix = on ne sait pas quelle ligne Shopify remise → pas de barré non plus. */
  function ownDiscounted(items, newP){
    var real = items.filter(function(x){ return !x.acc; });
    var pool = (real.length + 1 >= 2 ? real : items).map(function(x){ return x.p; });
    if (pool.indexOf(newP) > -1) return false;
    pool.push(newP);
    pool.sort(function(a, b){ return b - a; });
    return PCT[pool.indexOf(newP) % 3] > 0;
  }
  function feed(){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var key = 'bn-drawerkits2-' + cur;   // 04/11 : clé changée (flux avec prix barrés « c »)
    if (FEED && FEED.cur === cur) return Promise.resolve(FEED);
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.at < 30 * 60 * 1000) { FEED = c; return Promise.resolve(c); }
    } catch(e){}
    return fetch('/collections/best-sellers?view=drawerkits', {credentials: 'same-origin'})
      .then(function(r){ return r.text(); })
      .then(function(t){
        var d = JSON.parse(t); d.cur = cur; d.at = Date.now(); FEED = d;
        try { sessionStorage.setItem(key, JSON.stringify(d)); } catch(e){}
        return d;
      });
  }
  function getCart(){
    return fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); })
      .then(function(c){ CART = c; return c; });
  }
  function css(){
    if (document.getElementById('refonte-d3-css')) return;
    var s = document.createElement('style'); s.id = 'refonte-d3-css';
    s.textContent =
      '.refonte-d3{margin:0 0 16px;padding:12px;background:#FFF8EC;border:1px solid #EBDFC8;border-radius:10px}' +
      '.refonte-d3__title{margin:0 0 2px;font-size:14px;font-weight:700;color:#1a1a1a;line-height:1.3}' +
      '.refonte-d3__sub{margin:0 0 10px;font-size:11.5px;color:#7a6f5c;line-height:1.35}' +
      '.refonte-d3__row{display:flex;gap:8px;align-items:center;padding:8px 0;border-top:1px solid #EBDFC8}' +
      '.refonte-d3__row:first-of-type{border-top:0}' +
      '.refonte-d3__img{flex:0 0 52px;width:52px;height:52px;border-radius:6px;overflow:hidden;background:#f6f3ee;display:block}' +
      '.refonte-d3__img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.refonte-d3__info{flex:1 1 auto;min-width:0}' +
      '.refonte-d3__name{display:block;font-size:12px;font-weight:600;line-height:1.25;color:#1a1a1a;text-decoration:none;' +
        'overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
      '.refonte-d3__price{font-size:13px;font-weight:700;color:#1a1a1a;margin-top:2px}' +
      '.refonte-d3__lot{display:block;font-size:11px;font-weight:400;color:#7a7a7a;line-height:1.3}' +
      '.refonte-d3__price s{font-size:11px;font-weight:400;color:#9a9a9a;margin-right:4px}' +
      '.refonte-d3__save{display:inline-block;margin-top:3px;padding:1px 6px;border-radius:999px;background:#e3f4e6;color:#1d6b33;font-size:11px;font-weight:700}' +
      '.refonte-d3__add{flex:0 0 auto;align-self:center;border:1px solid #1a1a1a;border-radius:999px;background:#fff;color:#1a1a1a;' +
        'font-size:12px;font-weight:600;padding:6px 10px;cursor:pointer;white-space:nowrap;line-height:1.2}' +
      '.refonte-d3__add:hover{background:#1a1a1a;color:#fff}' +
      '.refonte-d3__add[disabled]{opacity:.6;cursor:default}' +
      /* colonne de 200 px sur ordinateur : bouton sous les infos */
      '.refonte-d3-m__title{margin:0 0 6px;font-size:13px;font-weight:700;color:#1a1a1a;line-height:1.3}' +
      '.refonte-d3-m__title--acc{margin:12px 0 6px}' +
      '.refonte-d3-m__row{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}' +
      '.refonte-d3-m__row::-webkit-scrollbar{display:none}' +
      '.refonte-d3-wrap{flex:0 0 82%;max-width:82%;min-width:0;display:flex;flex-direction:column;scroll-snap-align:start}' +
      '.refonte-d3-wrap > .refonte-d3-card{flex:1 1 auto;max-width:none}' +
      '.refonte-d3-lbl{display:block;height:18px;margin:0 0 4px;font-size:12.5px;font-weight:700;color:#1a1a1a;line-height:18px;white-space:nowrap}' +
      '@media (max-width:1024.98px){html body #minicart-form .cart-upsell-wrapper > .cart-upsell-item.refonte-d3-acc{flex-direction:column !important;align-items:stretch !important}}' +
      '.refonte-d3-card{flex:0 0 82%;max-width:82%;min-width:0;display:flex;align-items:center;gap:10px;padding:6px 8px;background:#FFFDF8;' +
        'border:1px solid #E6DCCD;border-radius:12px;min-height:54px;box-sizing:border-box;scroll-snap-align:start}' +
      '.refonte-d3-card__img{flex:0 0 40px;width:40px;height:40px;border-radius:6px;overflow:hidden;background:#f6f3ee;display:block}' +
      '.refonte-d3-card__img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.refonte-d3-card__info{flex:1 1 auto;min-width:0}' +
      '.refonte-d3-card__name{display:block;font-size:13px;line-height:1.25;color:#1a1a1a;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.refonte-d3-card__price{font-size:13px;font-weight:700;color:#1a1a1a;margin-top:2px;white-space:nowrap}' +
      '.refonte-d3-card__price s{font-size:11px;font-weight:400;color:#9a9a9a;margin-right:4px}' +
      '.refonte-d3-card__off{font-size:10.5px;font-weight:700;color:#1d6b33;background:#e3f4e6;border-radius:999px;padding:1px 5px;margin-left:2px}' +
      '.refonte-d3-card__add{flex:0 0 auto;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.3px;border:1px solid #CFC3AE;border-radius:999px;background:#fff;color:#1a1a1a;line-height:1.3;white-space:nowrap;cursor:pointer;padding:5px 10px;font-size:10.5px}' +
      '.refonte-d3-card__add[disabled]{opacity:.6}' +
      /* ORDINATEUR : présentation d'origine (vignette 52 px, nom, prix barré + prix), mais la pastille
         « Save » et le bouton « + Add » partagent une ligne (15/10, Robin) ; pas de marge négative
         (elle faisait déborder le bloc hors de la colonne). */
      '.refonte-d3-m__more{display:block;margin:6px 0 2px;text-align:left;font-size:12px;font-weight:600;color:#1a1a1a;text-decoration:underline;text-underline-offset:3px}' +
      '.refonte-d3__more{display:block;margin-top:6px;font-size:12px;font-weight:600;color:#1a1a1a;text-decoration:underline;text-underline-offset:3px}' +
      '.refonte-d3__foot{display:flex;align-items:center;justify-content:space-between;gap:6px;margin-top:4px}' +
      '@media (min-width:1025px){' +
        'html body .minicart__wrapper .cart-recommend.beside{width:24rem}' +
        'html body .minicart__wrapper .cart-recommend.beside .refonte-d3{margin:0 6px 4px !important;width:auto !important;padding:8px !important}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__name{font-size:12.5px}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__sub{display:none}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__title{margin-bottom:4px}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__row{display:grid;grid-template-columns:100px 1fr;column-gap:8px;align-items:start;padding:8px 0}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__img{width:100px;height:100px;grid-row:1 / span 4}' +
        /* ligne « Save / + Add » sur toute la largeur de la carte (la colonne ne fait que 200 px) */
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__info{display:contents}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__name{grid-column:2}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__price{grid-column:2}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__lotrow{grid-column:2;margin-top:3px;font-size:11px;color:#7a7a7a;line-height:1.3}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__foot{grid-column:2;justify-content:flex-start;margin-top:6px}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__save{margin-top:0}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__add{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.3px;border:1px solid #CFC3AE;border-radius:999px;background:#fff;color:#1a1a1a;line-height:1.3;white-space:nowrap;cursor:pointer;padding:4px 6px;width:auto}' +
        // 14/10 : prix du LOT plus long que la colonne → la grille débordait (prix et « + Add » collés au bord).
        // Colonne texte compressible + prix barré sur sa propre ligne.
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__row{grid-template-columns:100px minmax(0,1fr);row-gap:0;align-content:start}' +   // 15/10 : 8 px d\'écart hérité entre chaque ligne → trop aéré
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__price{min-width:0;white-space:normal}' +
        '.minicart__wrapper .cart-recommend.beside .refonte-d3__price s{display:inline;margin:0 0 0 3px}' +
        /* ACCESSOIRES « Complete your kit » : même présentation que les kits (15/10, Robin) */
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper {padding:0 14px 16px !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__wrapper{display:grid !important;grid-template-columns:100px 1fr;column-gap:8px;align-items:start;text-align:left !important;padding:9px 0 !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__inner{width:100px !important;margin:0 !important;grid-row:1 / span 2}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__wrapper img{width:100px !important;height:100px !important;object-fit:cover !important;border-radius:6px}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__information{text-align:left !important;align-items:flex-start !important;justify-content:flex-start !important;min-width:0}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__name,html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__name a{font-size:12px !important;font-weight:600 !important;text-align:left !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__price,html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .price{justify-content:flex-start !important;font-size:13px !important;font-weight:700}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-list-action{justify-content:flex-start !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .bls-add-cart-list,html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper .product-item__button-submit{margin:4px 0 0 !important;padding:4px 6px !important;font-size:10.5px !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .recommend-heading{padding:8px 14px 6px !important;min-height:0 !important;border-bottom:0 !important}' +
        'html body .minicart__wrapper .cart-recommend.beside .recommend-heading .minicart-heading{margin:0 !important}' +
        /* colonne défilable : les accessoires « Complete your kit » restent accessibles sous le bloc */
        'html body .minicart__wrapper .cart-recommend.beside{overflow-y:auto;overscroll-behavior:contain;padding:8px 0 12px !important}' +
        /* la colonne est en flex colonne : sans ça, la liste d'accessoires se tasse à ~100 px avec son
           propre défilement caché ; on fait défiler la colonne ENTIÈRE, comme avant le bloc */
        'html body .minicart__wrapper .cart-recommend.beside > *{flex-shrink:0}' +
        'html body .minicart__wrapper .cart-recommend.beside .cart-upsell-wrapper{overflow:visible;max-height:none}}';
    document.head.appendChild(s);
  }

  var MOBILE = window.matchMedia('(max-width: 1024.98px)');
  function clearAll(){
    document.querySelectorAll('#minicart-form .refonte-d3, #minicart-form .refonte-d3-card, #minicart-form .refonte-d3-wrap, #minicart-form .refonte-d3-m').forEach(function(n){ n.remove(); });
    var rec = document.querySelector('#minicart-form .cart-recommend'), grid = rec && rec.querySelector('.cart-upsell-wrapper');
    if (MOBILE.matches && grid) { css(); labelAcc(grid); }
  }
  /* 15/10 (Robin) : UNE rangée mais DEUX titres, posés au-dessus de chaque groupe DANS la rangée :
     « Add a 2nd kit… » au-dessus du 1er kit, « Complete your kit » au-dessus du 1er accessoire ;
     les autres cartes reçoivent une étiquette vide de même hauteur pour rester alignées. */
  function labelAcc(grid){
    var first = true;
    Array.prototype.forEach.call(grid.children, function(it){
      if (!it.classList.contains('cart-upsell-item')) return;
      var l = it.querySelector(':scope > .refonte-d3-lbl');
      if (!l) { l = document.createElement('span'); l.className = 'refonte-d3-lbl'; it.insertBefore(l, it.firstChild); }
      l.textContent = first ? 'Complete your kit' : '\u00a0';
      it.classList.add('refonte-d3-acc');
      first = false;
    });
  }
  function render(){
    var rec = document.querySelector('#minicart-form .cart-recommend');
    if (!rec || !CART || !FEED) { clearAll(); return; }
    var acc = FEED.acc || [];
    var base = [], inCart = [], fams = {};
    (CART.items || []).forEach(function(it){
      inCart.push(it.product_id);
      if (!it.price) return;
      var isAcc = acc.indexOf(it.product_id) > -1;
      if (!isAcc) fams[fam(it.product_type)] = (fams[fam(it.product_type)] || 0) + it.quantity;
      for (var q = 0; q < it.quantity; q++) base.push({p: it.price, acc: isAcc});
    });
    var kits = base.filter(function(x){ return !x.acc; }).length;
    // 15/10 (Robin) : aussi « Add a 2nd kit » dès 1 kit (puis 4, 7…) — le prochain kit prend −15 %
    var pos = kits % 3;                 // 1 → le suivant sera le 2e du groupe, 2 → le 3e
    // 14/10 (Robin) : lot de 3 complet → on continue, en invitant à commencer un NOUVEAU lot (comme la fiche)
    if (kits < 1) { clearAll(); return; }
    var top = Object.keys(fams).sort(function(a, b){ return fams[b] - fams[a]; })[0];
    var pool = (FEED.kits || []).filter(function(k){ return !k.multi && inCart.indexOf(k.id) < 0 && acc.indexOf(k.id) < 0; });
    var ordered = pool.filter(function(k){ return fam(k.type) === top; })
      .concat(pool.filter(function(k){ return fam(k.type) !== top; }));
    // 14/10 (Robin) : 2 kits, pour voir les accessoires. 17/10 : les 3e et 4e meilleures ventes éligibles (les deux
    // premières sont déjà en tête du Mix & match de la fiche) ; complété par les premières s'il en manque.
    var picks = ordered.slice(2, 4);
    ordered.slice(0, 2).forEach(function(k){ if (picks.length < 2) picks.push(k); });
    if (!picks.length) { clearAll(); return; }
    // 04/11/2026 (Robin, modèle Anavrin) : chaque kit à SON prix seul (barré si le kit a un prix barré) ;
    // plus de « +$X to your cart · Save $Y ». La remise par lots s'applique au panier, le titre la rappelle.
    var items = picks.map(function(k){ return {k: k}; });
    function priceHtml(k){ return money(k.p) + (k.c > k.p ? ' <s>' + money(k.c) + '</s>' : ''); }
    var pct = pos === 2 ? '20%' : '15%';
    var NEWLOT = 'Start a new bundle: 15% off the 2nd, 20% off the 3rd';
    css();

    /* TÉLÉPHONE ET TABLETTE (15/10, Robin) : pas de grand bloc — les kits se glissent EN TÊTE de la
       rangée horizontale des upsells, au même format que les cartes d'accessoires. */
    if (MOBILE.matches) {
      rec.style.removeProperty('padding');
      document.querySelectorAll('#minicart-form .refonte-d3, #minicart-form .refonte-d3-card').forEach(function(n){ n.remove(); });
      var grid = rec.querySelector('.cart-upsell-wrapper');
      if (!grid) { clearAll(); return; }
      document.querySelectorAll('#minicart-form .refonte-d3-wrap, #minicart-form .refonte-d3-m').forEach(function(n){ n.remove(); });
      var title = pos === 0 ? NEWLOT : kits <= 2 ? (pos === 2 ? 'Add a 3rd kit, save 20%' : 'Add a 2nd kit, save 15%') : 'Add one more kit, save ' + pct;
      var cards = items.map(function(x, n){
        return '<div class="refonte-d3-wrap"><span class="refonte-d3-lbl">' + (n === 0 ? esc(title) : '\u00a0') + '</span>' +
          '<div class="refonte-d3-card">' +
          '<a class="refonte-d3-card__img" href="' + esc(x.k.u) + '"><img src="' + esc(x.k.img) + '" alt="" loading="lazy"></a>' +
          '<div class="refonte-d3-card__info"><a class="refonte-d3-card__name" href="' + esc(x.k.u) + '">' + esc(x.k.t) + '</a>' +
          '<div class="refonte-d3-card__price">' + priceHtml(x.k) + '</div></div>' +
          '<button type="button" class="refonte-d3-card__add" data-d3-add="' + x.k.v + '" aria-label="Add ' + esc(x.k.t) + ' to cart">+ Add</button>' +
        '</div></div>';
      }).join('');
      grid.insertAdjacentHTML('afterbegin', cards);
      labelAcc(grid);
      grid.scrollLeft = 0;
      // 04/11 (Robin) : même lien que sur ordinateur, discret, sous la rangée d'upsells (classe refonte-d3-m : retiré par clearAll)
      grid.insertAdjacentHTML('afterend', '<a class="refonte-d3-m refonte-d3-m__more" href="/pages/build-your-bundle">Build your own bundle &rarr;</a>');
      return;
    }

    // ORDINATEUR : bloc en tête de la colonne « Complete your kit »
    rec.style.setProperty('padding', '8px 0 12px', 'important');
    document.querySelectorAll('#minicart-form .refonte-d3-m, #minicart-form .refonte-d3-wrap, #minicart-form .cart-upsell-item > .refonte-d3-lbl').forEach(function(n){ n.remove(); });
    document.querySelectorAll('#minicart-form .refonte-d3-card').forEach(function(n){ n.remove(); });
    var old = document.querySelector('#minicart-form .refonte-d3');
    var rows = items.map(function(x){
      var k = x.k;
      return '<div class="refonte-d3__row">' +
        '<a class="refonte-d3__img" href="' + esc(k.u) + '"><img src="' + esc(String(k.img).replace(/([?&]width=)\d+/, '$1300')) + '" alt="" loading="lazy"></a>' +   // 100 px affichés : 300 px pour les écrans Retina
        '<div class="refonte-d3__info"><a class="refonte-d3__name" href="' + esc(k.u) + '">' + esc(k.t) + '</a>' +
        '<div class="refonte-d3__price">' + priceHtml(k) + '</div>' +
        // 15/10 (Robin) : bouton au style de celui des accessoires, seul sur sa ligne
        '<div class="refonte-d3__foot">' +
        '<button type="button" class="refonte-d3__add" data-d3-add="' + k.v + '" aria-label="Add ' + esc(k.t) + ' to cart">+ Add</button></div>' +
        '</div></div>';
    }).join('');
    var html = '<p class="refonte-d3__title">' + (pos === 0 ? NEWLOT : kits <= 2 ? (pos === 2 ? 'Add a 3rd kit, save 20%' : 'Add a 2nd kit, save 15%')
                                                    : 'Add one more kit, save ' + pct) + '</p>' +
               '<p class="refonte-d3__sub">' + (pos === 0 ? 'The deal repeats on every 3 kits, applied automatically.' : 'Your next kit gets the bundle discount automatically.') + '</p>' + rows +
               '<a class="refonte-d3__more" href="/pages/build-your-bundle">Build your own bundle &rarr;</a>';
    if (old) { old.innerHTML = html; return; }
    var box = document.createElement('div');
    box.className = 'refonte-d3';
    box.innerHTML = html;
    rec.insertBefore(box, rec.firstChild);
  }
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', function(){ render(); });
  function refresh(){
    return Promise.all([feed(), getCart()]).then(render).catch(function(){});
  }
  function schedule(){ clearTimeout(timer); timer = setTimeout(refresh, 150); }

  function sectionsToRender(){
    var cn = document.querySelector('cart-notification');
    try { if (cn && typeof cn.getSectionsToRender === 'function') return cn.getSectionsToRender().map(function(s){ return s.id; }); } catch(e){}
    return ['minicart-form'];
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-d3-add]');
    if (!btn || busy) return;
    e.preventDefault(); e.stopPropagation();
    busy = true; btn.disabled = true; btn.textContent = 'Adding…';
    var secs = sectionsToRender();
    fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: [{id: parseInt(btn.getAttribute('data-d3-add'), 10), quantity: 1}], sections: secs, sections_url: location.pathname})})
      .then(function(r){ return r.json(); })
      // 15/10 : on relit le panier AVANT de remplacer le tiroir, pour ré-injecter le bloc dans la même
      // tâche que le re-rendu : sans ça, les accessoires remontaient une demi-seconde (bloc absent)
      .then(function(data){ return getCart().then(function(){ return data; }); })
      .then(function(data){
        try {
          SYNC = true;
          if (data && data.sections) {
            secs.forEach(function(sid){
              if (!data.sections[sid]) return;
              var parsed = new DOMParser().parseFromString(data.sections[sid], 'text/html');
              var fresh = parsed.querySelector('#' + sid) || parsed.querySelector('#minicart-form') || parsed.body;
              var live = document.getElementById(sid);
              if (fresh && live) live.innerHTML = fresh.innerHTML;
            });
          }
          render();
          SYNC = false;
          var cn = document.querySelector('cart-notification');
          if (cn && typeof cn.cartAction === 'function') cn.cartAction();
        } catch(e){ SYNC = false; }
        return Promise.resolve(CART).then(function(cart){
          try {
            document.querySelectorAll('.cart-count').forEach(function(c){
              if (c.classList.contains('cart-count-drawer')) c.innerHTML = '(' + cart.item_count + ')';
              else c.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
            });
          } catch(e){}
          if (window.bnTrackSource) window.bnTrackSource('drawer3', cart);
          else {
            var a = {}; a._bn_src_drawer3 = String((parseInt((cart.attributes || {})._bn_src_drawer3, 10) || 0) + 1);
            fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: a})}).catch(function(){});
          }
        });
      })
      .catch(function(){ location.href = '/cart'; })
      .then(function(){ busy = false; refresh(); });
  }, true);

  function watch(){
    var form = document.getElementById('minicart-form');
    if (form && window.MutationObserver) new MutationObserver(function(muts){
      // seulement les re-rendus du thème (enfants directs remplacés), pas nos propres injections
      // re-rendu du thème : on ré-injecte TOUT DE SUITE avec les dernières données connues (l'observateur
      // passe avant l'affichage, donc pas d'image sans le bloc), puis on rafraîchit avec le vrai panier
      for (var i = 0; i < muts.length; i++) { if (muts[i].target === form) { if (!SYNC) { render(); schedule(); } return; } }
    }).observe(form, {childList: true});
    var cc = document.querySelector('.cart-count');
    if (cc && window.MutationObserver) new MutationObserver(schedule).observe(cc, {childList: true, characterData: true, subtree: true});
    window.bnDrawer3Refresh = refresh;   // pour les tests
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* TIROIR COINCÉ — CORRECTIF DE FOND (14/10/2026). Deux courses de vitesse dans theme.js
     (CartNotification), reproduites :
     A. open() pose `open-minicart` / `open-drawer` sur <html> 100 ms APRÈS l'ouverture ; une
        fermeture dans ces 100 ms (double clic, clic à côté pendant l'animation) laisse la page
        marquée « tiroir ouvert » alors qu'il est fermé (capture de Robin du 13/10).
     B. close() retire les classes 500 ms plus tard quand la colonne d'upsells est ouverte ; une
        réouverture dans ce délai est annulée : le tiroir se referme tout seul.
     On retient la DERNIÈRE action demandée et on corrige tout minuteur en retard qui la contredit. */
  customElements.whenDefined('cart-notification').then(function(){
    var C = customElements.get('cart-notification');
    if (!C || C.prototype.__bnPatched) return;
    C.prototype.__bnPatched = true;
    var LAST = 'close', root = document.documentElement;
    function wrap(){ return document.querySelector('cart-notification .minicart__wrapper'); }
    function otherDrawerOpen(){
      return !!document.querySelector('.bls__drawer.open:not(.minicart__wrapper), .bls__drawer.active:not(.minicart__wrapper)');
    }
    function enforce(){
      var w = wrap(), cn = document.querySelector('cart-notification');
      if (!w || !cn) return;
      if (LAST === 'open') {
        if (!w.classList.contains('open')) w.classList.add('open');
        if (!cn.classList.contains('open')) cn.classList.add('open');
        if (!cn.classList.contains('show_popup')) {
          if (!root.classList.contains('open-minicart')) root.classList.add('open-minicart');
          if (!root.classList.contains('open-drawer')) root.classList.add('open-drawer');   // voile + blocage du défilement
        }
      } else {
        if (root.classList.contains('open-minicart')) root.classList.remove('open-minicart');
        if (!otherDrawerOpen() && root.classList.contains('open-drawer')) {
          root.classList.remove('open-drawer');
          root.style.removeProperty('padding-right');
        }
        var rec = document.querySelector('.cart-recommend');
        if (rec && rec.classList.contains('open')) rec.classList.remove('open');
      }
    }
    var t1, t2, t3;
    function later(){
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
      t1 = setTimeout(enforce, 150); t2 = setTimeout(enforce, 650); t3 = setTimeout(enforce, 1150);
    }
    // ⚠️ la croix du tiroir est branchée par le thème sur `this.close.bind(this)` AU CHARGEMENT :
    // elle appelle la fonction d'origine, pas la version enveloppée ci-dessous. On capte donc le
    // clic lui-même (phase de capture, avant le thème) pour savoir qu'une fermeture est demandée.
    document.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest('cart-notification .close-cart-button, cart-notification .close-cart')) { LAST = 'close'; later(); }
    }, true);
    // icône panier cliquée PENDANT une fermeture : close() du thème remet `open` sur le tiroir le
    // temps de l'animation, donc l'icône croit le tiroir ouvert et le referme. On retire cette marque
    // juste avant le thème pour que le clic ROUVRE le panier, comme le client s'y attend.
    document.addEventListener('click', function(e){
      if (!(e.target.closest && e.target.closest('.minicart__action'))) return;
      var w = wrap();
      if (LAST === 'close' && w && w.classList.contains('open')) w.classList.remove('open');
    }, true);
    var origOpen = C.prototype.open, origClose = C.prototype.close;
    C.prototype.open = function(){ LAST = 'open'; var r = origOpen.apply(this, arguments); later(); return r; };
    C.prototype.close = function(){ LAST = 'close'; var r = origClose.apply(this, arguments); later(); return r; };
    // garde immédiate : un minuteur du thème qui retire `open` alors qu'on vient de rouvrir est
    // corrigé dans la même tâche (pas de clignotement)
    var w0 = wrap();
    if (w0 && window.MutationObserver) {
      new MutationObserver(function(){
        if (LAST === 'open' && !w0.classList.contains('open')) w0.classList.add('open');
      }).observe(w0, {attributes: true, attributeFilter: ['class']});
      new MutationObserver(function(){
        if (LAST === 'close' && root.classList.contains('open-minicart')) root.classList.remove('open-minicart');
      }).observe(root, {attributes: true, attributeFilter: ['class']});
    }
  });
})();

